import React, { useState } from 'react';
import BZPopover from 'BZPopover';
import LoginPopover from '../../LoginPopover';
import classnames from 'classnames';
import { getTimeToSessionStartInMs } from '../../sessionBroadcastUtils';
import { useTimeout } from '../../../../../utils/ReactHooks';
import {
    sendCustomClick
} from '../../../../../utils/SnowplowUtils';
import {
    buttonTypes,
    rateSessionSubCategory
} from '../../../../../constants/SnowplowConst';
import { loginClickOrigin } from '../../../../../constants/Enums';
import { MAX_TIMEOUT_MILLISECONDS } from '../../../../../constants/Numbers';

export default function SessionRate({
    event,
    rate,
    feedback,
    settings,
    me,
    eventUrls,
    session,
    showEmailLogin,
    sendRate,
    siteConf,
    setLoginV2OffsetTop,
    sessionViewType,
}) {

    function hidePopover() {
        document.body.click();
    }

    const [rateSelected, setRateSelected] = React.useState(-1);
    const [feedbackText, setFeedbackText] = React.useState(undefined);

    function sendRateClicked(e) {
        sendCustomClick(buttonTypes.rateSession, rateSessionSubCategory.submitRateFeedbackForm, e.currentTarget);
        sendRate({
            eventId: event.id,
            sessionId: session.id,
            rate: rateSelected,
            feedback: feedbackText
        }).then(() => {
            hidePopover();
        });
    }

    function changeRateSelected(idx) {
        let rate = idx + 1;
        if (rate === rateSelected) {
            rate = 0;
        }
        setRateSelected(rate);
    }

    if (!settings?.allowRating) {
        return null;
    }

    const eventTimeZone = event && event['time-zone-id'];
    const {startDate, startMinute} = session;
    const isVirtualSession = session?.enableVirtualSession;
    const isScheduledSession = !!startDate;
    const timeToScheduledSessionStart = isScheduledSession
        ? getTimeToSessionStartInMs({ startDate, startMinute, eventTimeZone })
        : 0;
    const twoMinBeforeScheduledSessionStart = timeToScheduledSessionStart > 0
        ? timeToScheduledSessionStart - (2*60*1000)
        : 0;
    const timeToSessionStart = isVirtualSession
        ? twoMinBeforeScheduledSessionStart
        : timeToScheduledSessionStart;
    const isRateAllowedBeforeSessionStart = !settings?.rateAfterSessionStart;
    const isSessionStarted = timeToSessionStart < 0;
    const isSessionSoon = timeToSessionStart <= MAX_TIMEOUT_MILLISECONDS;

    const [isRateEnabled, enableRate] = useState(isRateAllowedBeforeSessionStart || isSessionStarted);

    useTimeout(
        () => enableRate(true),
        settings.rateAfterSessionStart && isScheduledSession && isSessionSoon ? timeToSessionStart : null
    );

    if (rateSelected === -1) {
        setRateSelected(rate || 0);
    }

    let hearts = [];
    let selectedHearts = [];

    for (let i = 0; i < (rate || 0); i++) {
        hearts.push(<HeartIcon cls={'location-icon small-hearts'} iconType={'AgendaAtt_love'} fontSize={13} />);
    }
    for (let i = 0; i < 5 - (rate || 0); i++) {
        hearts.push(<HeartIcon cls={'location-icon small-hearts'} iconType={'AgendaAtt_heart'} fontSize={13} />);
    }

    for (let i = 0; i < rateSelected; i++) {
        selectedHearts.push(<HeartIcon cls={'location-icon'} iconType={'AgendaAtt_love'} fontSize={18} />);
    }
    for (let i = 0; i < 5 - rateSelected; i++) {
        selectedHearts.push(<HeartIcon cls={'location-icon'} iconType={'AgendaAtt_heart'} fontSize={18} />);
    }

    const rateClickHandler = (e, category) =>
        sendCustomClick(buttonTypes.rateSession, category, e.currentTarget);

    const button = (
        <div className="hearts-container" onClick={(e) => rateClickHandler(e, rateSessionSubCategory.clickRateOnPage)}>
            <span className="rate-title custom-color color-1 font-size-13">Rate Session</span>
            {
                hearts.map((heart, idx) => (
                    <span className='heart_wrapper' key={`heart-${idx}`}>{heart}</span>
                ))
            }
        </div>);

    if (!me.id) {
        return <BZPopover
            placement="bottom"
            cls="need-login-popover"
            button={button}
            popover={
                <LoginPopover
                    eventUrls={eventUrls}
                    onLoginClick={showEmailLogin}
                    setLoginV2OffsetTop={setLoginV2OffsetTop}
                    isWidget={siteConf?.isWidget}
                    analyticData={{
                        clickOrigin: sessionViewType === 'sessionPreviewWindow'
                            ? loginClickOrigin.sessionPreview.rateHeart
                            : loginClickOrigin.session.rateHeart,
                        sessionId: session?.id,
                    }}
                />
            }
        />;
    }

    const heartContainerCls = classnames('hearts-container pull-right', {disabled: !isRateEnabled});

    return <BZPopover
        placement="bottom"
        cls="agenda-rate-popover"
        button={button}
        popover={
            <div>
                <div className="text text-left rate-wrapper">
                    <span className="text-semi-bold">RATE THIS SESSION (1-5)</span>
                    <span className={heartContainerCls}>
                        {selectedHearts.map((heart, idx) => (
                            <span key={`heart-${idx}`}
                                onClick={(e) => {
                                    if (!isRateEnabled) {
                                        return;
                                    }
                                    changeRateSelected(idx);
                                    rateClickHandler(e, rateSessionSubCategory.setActualSessionRate);
                                }}>{heart}</span>
                        ))}
                    </span>
                </div>
                {!isRateEnabled && <div>
                    <div className="text feedback-text  margin-top-small">
                        <span className="text-semi-bold">SESSION RATING AND FEEDBACK IS ONLY AVAILABLE ONCE SESSION STARTS</span>
                    </div>
                    <div className="margin-bottom-small text-center">
                        <a className="custom-color color-1 cancel-button"
                            onClick={hidePopover}> CLOSE</a>
                    </div>
                </div>}

                {isRateEnabled && <div>
                    <div className="text feedback-text">
                        <span className="text-semi-bold">LEAVE FURTHER FEEDBACK</span>
                    </div>
                    <textarea type="text" value={feedbackText === undefined ? feedback : feedbackText}
                        className="form-control rate-popover"
                        onChange={(e) => setFeedbackText(e.target.value)}/>
                    <span className="margin-vertical-small pull-right">
                        <a className='btn custom-color color-1-background text-color-white font-size-12 send-button'
                            onClick={sendRateClicked}> SEND </a>
                    </span>
                    <span className="margin-vertical-small pull-left">
                        <a className="custom-color color-1 cancel-button"
                            onClick={() => {
                                hidePopover();
                                setRateSelected(rate);
                                setFeedbackText(feedback);
                            }
                            }> Cancel</a>
                    </span>
                </div>}

            </div>
        }
    />;
}

const HeartIcon = ({ cls, iconType, fontSize }) => (
    <i className={`${cls} fa icon-${iconType} custom-color color-1 font-size-${fontSize}`}/>
);
